import PaymentsPage from './PaymentsPage';

export default PaymentsPage;
